import { render, staticRenderFns } from "./alertMessageBox.vue?vue&type=template&id=a880e58e"
import script from "./alertMessageBox.vue?vue&type=script&lang=js"
export * from "./alertMessageBox.vue?vue&type=script&lang=js"
import style0 from "./alertMessageBox.vue?vue&type=style&index=0&id=a880e58e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports